import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { fetchActiveGroup } from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";

const { Option } = Select;

const GroupLoader = ({onChange, selectedGroup}) => {
    document.title = 'Group Loader';
    const [groups, setGroup] = useState([]);
    const [loading, setLoading] = useState(false);
    const [debounceTimeout, setDebounceTimeout] = useState(null);


    useEffect(() => {
        if (selectedGroup && selectedGroup.length > 0) {
            setGroup(selectedGroup);
        }
    }, [selectedGroup]);

    const handleGroupSelect = (value, option) => {
        if (onChange && option && option.length > 0) {
            const dataToSend = option.map((opt) => {
                const convertedId = opt.data._id ? opt.data._id : opt.data.fkGroupId;
                const newData =  {
                    groupName:opt.data.groupName,
                    groupFullName:opt.data.groupFullName,
                    fkGroupId: convertedId || opt.data._id, 
                };
                delete newData._id;
                return newData;
            });
            onChange(dataToSend);
        }
    };

    const handleSearchChange = (value) => {
        // Clear the existing timeout
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Set a new timeout to trigger the API call after 500 milliseconds of inactivity
        const timeout = setTimeout(() => {
            loadGroups();
        }, 500);

        setDebounceTimeout(timeout);
    };

    const loadGroups = async () => {
        try {
            setLoading(true);

            let groupObj = {
                projection: {
                    groupFullName: 1,
                    groupName:1
                },
            };
            
            groupObj['companyId'] = global_var.company_id;
            groupObj['rmId'] = global_var.roleMappingId;
            groupObj['fkAcademicYearId'] = global_var.academicYearName;
            groupObj['checkClassDivisionAccess'] = true;

            let response = await fetchActiveGroup(groupObj);

            try {
                let responseData = response.data.groups;
                if (Array.isArray(responseData) && responseData.length > 0) {
                    if (selectedGroup && selectedGroup.length > 0) {
                        const updatedGroup = [...selectedGroup, ...responseData];
                        setGroup(updatedGroup);
                    }else{
                        setGroup(responseData);
                    }
                    setGroup(responseData);
                } else {
                    setGroup([]);
                }
            } catch (error) {
                console.error('Error parsing JSON:', error);
                setGroup([]);
            }
        } catch (error) {
            console.error('Error fetching groups:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Select
                mode="multiple"
                placeholder="Select group"
                style={{ width: '100%' }}
                onChange={handleGroupSelect}  
                onSearch={handleSearchChange} 
                optionLabelProp="label"
                showSearch
                loading={loading}
                value={selectedGroup && selectedGroup.length > 0 ? selectedGroup.map(selecGroup => selecGroup.groupFullName) : undefined}
            >
                {groups.map((group) => (
                    <Option key={group.groupFullName} data={group} value={group.groupFullName} label={group.groupFullName}>
                        {group.groupFullName}
                    </Option>
                ))}
            </Select>
        </div>
    );
};

export default GroupLoader;
